// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3F-eS","modalForm":"UpgradeEpcsModal_modalForm__2j-77","modalFooter":"UpgradeEpcsModal_modalFooter__2IIm_"};